import type { QuestionProps } from '../eform.types'

export default function HiddenField({  value }: QuestionProps) {
  return <input type="hidden" value={Array.isArray(value) ? value[0] ?? '' : value} readOnly />
}
